module.exports = __webpack_public_path__ + "img/img-default-phone.5e6b5745.png";